import AppConstants from '../constants/appConstants';

/**
 * Serviço para cadastro de lojistas sem autenticação
 */
class DealerRegistrationService {
  constructor() {
    // Certifique-se de adicionar NEW_URL_API_INSTACARRO e NEW_URL_API_INSTACARRO_API_KEY
    // nas constantes do ambiente (appConstants.sand.js e appConstants.prod.js)
    this.baseURL = AppConstants.NEW_URL_API_INSTACARRO || '';
    this.apiKey = AppConstants.NEW_URL_API_INSTACARRO_API_KEY || '';
  }

  /**
   * Formata CNPJ para o padrão XX.XXX.XXX/XXXX-XX
   */
  formatCNPJ(cnpj) {
    if (!cnpj) return '';
    const cleaned = cnpj.replace(/\D/g, '');
    if (cleaned.length !== 14) return cnpj;
    return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  /**
   * Formata CEP para o padrão XXXXX-XXX
   */
  formatCEP(cep) {
    if (!cep) return '';
    const cleaned = cep.replace(/\D/g, '');
    if (cleaned.length !== 8) return cep;
    return cleaned.replace(/^(\d{5})(\d{3})$/, '$1-$2');
  }

  /**
   * Transforma os dados do formulário no payload esperado pela API
   */
  transformToApiPayload(formData) {
    const {
      // Dados pessoais
      firstName,
      lastName,
      email,
      phoneNumber,
      // Dados da empresa
      cnpj,
      socialReason,
      fantasyName,
      legalNature,
      // Dados do Representante Legal
      legalRepName,
      legalRepBirthDate,
      legalRepCpf,
      // Endereço
      zipcode,
      street,
      number,
      complement,
      neighborhood,
      municipality,
      state,
      // Atividades
      principalActivity,
      secondaryActivities,
      // Sistema
      relatedNinja,
    } = formData;

    const payload = {
      profile: {
        dealershipName: socialReason, // Nome da Loja = Razão Social
        relatedNinja: relatedNinja || 'felipe.nascimento@instacarro.com',
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
      },
      companyInfo: {
        principalActivity: principalActivity,
        secondaryActivity: Array.isArray(secondaryActivities)
          ? secondaryActivities
          : [secondaryActivities],
        legalNature: legalNature,
        fantasyName: fantasyName,
        socialReason: socialReason,
        receitaFederalStatus: fantasyName, // Mesmo valor do Nome Fantasia
        receitaFederalEmail: email.toLowerCase().trim(),
        legalRepresentative: {
          name: legalRepName,
          birthDate: legalRepBirthDate,
          cpf: legalRepCpf?.replace(/\D/g, ''),
        },
        cnpjInfo: {
          taxIdentificationNumber: this.formatCNPJ(cnpj),
          socialReason: socialReason,
          fantasyName: fantasyName,
          address: {
            neighborhood: neighborhood,
            zipcode: this.formatCEP(zipcode),
            complement: complement || '',
            street: street,
            municipality: municipality,
            number: number,
            state: state.toUpperCase(),
          },
        },
      },
      email: email.toLowerCase().trim(),
      // Adiciona campos de sessão do checkout se existirem
      ...(formData.checkout_session_id && {
        checkout_session_id: formData.checkout_session_id,
      }),
      ...(formData.client_reference_id && {
        client_reference_id: formData.client_reference_id,
      }),
      ...(formData.session_data && {
        session_data: formData.session_data,
      }),
      // Timestamps
      createdAt: new Date().toISOString(),
      submittedAt: new Date().toISOString(),
    };

    console.log('🔍 Payload transformado:', JSON.stringify(payload, null, 2));
    
    return payload;
  }

  /**
   * Cria uma nova empresa/lojista
   */
  async createCompany(formData) {
    try {
      console.log('📥 FormData recebido:', formData);
      
      const payload = this.transformToApiPayload(formData);

      console.log('🚀 Enviando para:', `${this.baseURL}/v1/pipelines/create-company-from-form`);
      
      const response = await fetch(`${this.baseURL}/v1/pipelines/create-company-from-form`, {
        method: 'POST',
        headers: {
          'x-api-key': this.apiKey,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      
      console.log('📨 Resposta do servidor:', {
        status: response.status,
        ok: response.ok,
        data: data,
      });

      if (!response.ok) {
        // Tratamento de erros específicos
        if (data.code === 1004) {
          throw new Error('Esta empresa já está cadastrada no sistema.');
        }
        if (data.code === 500) {
          console.error('❌ Erro 500 do servidor:', data.message);
          throw new Error(`Erro no servidor: ${data.message}`);
        }
        throw new Error(data.message || 'Erro ao cadastrar empresa');
      }

      return data;
    } catch (error) {
      console.error('❌ Erro ao criar empresa:', error);
      throw error;
    }
  }

  /**
   * Busca informações do CNPJ na Receita Federal
   * (Implementar se houver um endpoint disponível)
   */
  async searchCNPJ(cnpj) {
    // TODO: Implementar busca na Receita Federal se houver endpoint
    throw new Error('Funcionalidade não implementada');
  }
}

export const dealerRegistrationService = new DealerRegistrationService();
export default DealerRegistrationService;
